module.exports = __webpack_public_path__ + "static/media/shooting-star-icon.d727939b.png";